import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent } from 'rxjs';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { heightDirective } from '../../../../shared/directives/height.directive';
import { WidthDirective } from '../../../../shared/directives/width.directive';
import { OtsStaffOrderStatus } from '../../core/types';

@Component({
  selector: 'ots-staff-status-filter',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, heightDirective, WidthDirective],
  templateUrl: './staff-status-filter.component.html',
  styleUrl: './staff-status-filter.component.scss',
  host: { class: 'ots-staff-filter-wrap position-relative' }
})
export class StaffStatusFilterComponent extends BaseComponent {

  @Input() public options: { id: OtsStaffOrderStatus; label: string; checked: boolean }[] = [];

  @Input() public filtersActive = false;

  @Output() public statusToggled = new EventEmitter<OtsStaffOrderStatus>();

  protected readonly isFilterMenuOpen = signal(false);

  public ngOnInit(): void {
    fromEvent<MouseEvent>(document, 'click').pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(event => {
      if (!this.isFilterMenuOpen()) {
        return;
      }

      const target = event.target;
      if (target instanceof Node && this.elementRef.nativeElement.contains(target)) {
        return;
      }

      this.isFilterMenuOpen.set(false);
    });
  }

  protected toggleFilterMenu(event: Event): void {
    event.stopPropagation();
    this.isFilterMenuOpen.update(isFilterMenuOpen => !isFilterMenuOpen);
  }

  protected toggleStatus(status: OtsStaffOrderStatus): void {
    this.statusToggled.emit(status);
  }
}
